import { attr, fk } from 'redux-orm'
import Base from './Base'

class EventLocationTag extends Base {
  static get fields() {
    return {
      id: attr(),
      locationId: fk({to: 'location', as: 'location', relatedName: 'eventLocationTag'}),
      eventId: fk({to: 'event', as: 'event', relatedName: 'eventLocationTags'}),
    }
  }
}

EventLocationTag.modelName = 'eventLocationTag'

export default EventLocationTag;
